import React, { useState, useEffect, useRef } from "react";
import "./CategoryPage.css"; // Ensure CSS styles are correct
import Navbar from "./Navbar";
// import Footer from "./layouts/Footer";

const CategoryPage = () => {
  const [inStock, setInStock] = useState(false);
  const [outOfStock, setOutOfStock] = useState(false);
  const [priceRange, setPriceRange] = useState([0, 740]);
  const [sortBy, setSortBy] = useState("Best selling");
  const [viewStyle, setViewStyle] = useState("grid");
  const [dropdownOpen, setDropdownOpen] = useState(false); // Manage dropdown state

  const dropdownRef = useRef(null); // To detect clicks outside the dropdown

  const sortOptions = [
    "Featured",
    "Best selling",
    "Alphabetically, A-Z",
    "Alphabetically, Z-A",
    "Price, low to high",
    "Price, high to low",
    "Date, old to new",
    "Date, new to old",
  ];

  const products = [
    {
      id: 1,
      title: "White Cartridge Paper",
      description: "140 GSM",
      price: 84,
      imgUrl: "/assets/images/auth/img-auth-1.jpg",
    },
    {
      id: 2,
      title: "Ivory Paper",
      description: "220 GSM",
      price: 112,
      imgUrl: "/assets/images/auth/img-auth-2.jpg",
    },
    {
      id: 3,
      title: "Portfolio File",
      description: "With Elastic Band",
      price: 500,
      imgUrl: "/assets/images/auth/img-auth-3.jpg",
    },
  ];

  const handleSortSelect = (option) => {
    setSortBy(option);
    setDropdownOpen(false);
  };

  // Detect click outside the dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
    <Navbar/>
      <div className="product-page-container">
        <div className="filter-sidebar">
          <div className="filter-section">
            <h4>AVAILABILITY</h4>
            <label>
              <input
                type="checkbox"
                checked={inStock}
                onChange={() => setInStock(!inStock)}
              />
              In Stock (32)
            </label>
            <label>
              <input
                type="checkbox"
                checked={outOfStock}
                onChange={() => setOutOfStock(!outOfStock)}
              />
              Out of Stock (0)
            </label>
          </div>

          <div className="filter-section">
            <h4>PRICE</h4>
            <div className="price-range">
              <input
                type="range"
                min={0}
                max={740}
                value={priceRange[1]}
                onChange={(e) => setPriceRange([0, Number(e.target.value)])}
              />
              <div className="price-values">
                ₹ {priceRange[0]} to ₹ {priceRange[1]}
              </div>
              <button className="btn btn-danger">APPLY</button>
            </div>
          </div>
        </div>

        <div className="product-listing">
          <div className="view-options">
            <div className="view-style">
              <span>VIEW AS</span>
              <button
                className={`btn-view ${viewStyle === "list" ? "active" : ""}`}
                onClick={() => setViewStyle("list")}
              >
                <i className="fas fa-list"></i>
              </button>
              <button
                className={`btn-view ${viewStyle === "grid" ? "active" : ""}`}
                onClick={() => setViewStyle("grid")}
              >
                <i className="fas fa-th-large"></i>
              </button>
            </div>

            <div className="dropdown" ref={dropdownRef}>
              <button
                className="dropdown-toggle"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                {sortBy}
              </button>
              <ul className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}>
                {sortOptions.map((option) => (
                  <li key={option} onClick={() => handleSortSelect(option)}>
                    {option}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className={`products-container ${viewStyle}`}>
            {products.map((product) => (
              <div key={product.id} className="product-card">
                <img src={product.imgUrl} alt={product.title} />
                <h5>{product.title}</h5>
                <p>{product.description}</p>
                <p>
                  <strong>From ₹ {product.price}</strong>
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <Footer/> */}
    </>
  );
};

export default CategoryPage;
